import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const ScanRoute: Route = {
  path: 'scan',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/scan.component').then((m) => m.ScanComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
